  /** The enum UserType. */
  export enum UserType {
    ADMINISTRATOR = 1,
    Manufacturer = 2,
    DISTRIBUTOR = 3,
    USER = 4
  }
